import loadable from '@loadable/component'

export const AnalystSummary = loadable(() => import('./AnalystSummary'))
export type { AnalystSummaryProps } from './AnalystSummary'